import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

export default function useDataEngineNullableObjects() {
	const { t: $t } = useI18n()

	const dataEngineNullableObjects = computed(() => {
		return {
			legalEntityIfNotValueObj: {
				id: -1,
				name: $t('Not specified'),
			},
			clusterIfNotValueObj: {
				id: -1,
				name: $t('Not specified'),
			},
			fieldIfNotValueObj: {
				id: -1,
				title: $t('Not specified'),
				__ao__title: $t('Not specified'),
			},
			cultureIfNotValueObj: {
				id: -1,
				title: $t('Not specified'),
				iconKey: 'question-circle',
			},
			objectTypeIfNotValueObj: {
				id: -1,
				name: $t('Not specified'),
			},
			contractorIfNotValueObj: {
				id: -1,
				fullname: $t('Not specified'),
			},
			infrastructureOwnershipIfNotValueObj: {
				value: -1,
				title: $t('Not specified'),
			},
			infrastructureTypeIfNotValueObj: {
				value: -1,
				title: $t('Not specified'),
			},
			infrastructureIfNotValueObj: {
				id: -1,
				name: $t('Not specified'),
			},
			machineIfNotValueObj: {
				id: -1,
				brand: $t('Not specified'),
				__ao__title: $t('Not specified'),
			},
			machineTypeIfNotValueObj: {
				value: -1,
				title: $t('Not specified'),
			},
			deviceIfNotValueObj: {
				if: -1,
				imei: $t('Not specified'),
				key: $t('Not specified'),
				title: $t('Not specified'),
			},
			equipmentIfNotValueObj: {
				id: -1,
				brand: $t('Not specified'),
				__ao__title: $t('Not specified'),
			},
			equipmentTypeIfNotValueObj: {
				value: -1,
				title: $t('Not specified'),
			},
			workIfNotValueObj: {
				id: -1,
				name: $t('Not specified'),
			},
			workCategoryIfNotValueObj: {
				id: -1,
				name: $t('Not specified'),
			},
			staffIfNotValueObj: {
				id: -1,
				name: $t('Not specified'),
			},
			responsibleStaffIfNotValueObj: {
				id: -1,
				name: $t('Not assigned'),
			},
			inspectionTemplateIfNotValueObj: {
				id: -1,
				name: $t('Not specified'),
			},
			inspectionReportIfNotValueObj: {
				id: -1,
				name: $t('Not specified'),
			},
			trialPlotIfNotValueObj: {
				id: -1,
				name: $t('Not specified'),
			},
			roleIfNotValueObj: {
				id: -1,
				name: $t('Not specified'),
			},
			regulationIfNotValueObj: {
				id: -1,
				name: $t('Not specified'),
			},
			regulationTypeIfNotValueObj: {
				value: -1,
				title: $t('Not specified'),
			},
			stageIfNotValueObj: {
				id: -1,
				name: $t('Not specified'),
			},
			workTypeIfNotValueObj: {
				value: -1,
				title: $t('Not specified'),
			},
			staffPaymentIfNotValueObj: {
				id: -1,
				name: $t('Not specified'),
			},
			metricIfNotValueObj: {
				value: -1,
				title: $t('Not specified'),
			},
			monthsIfNotValueObj: {
				value: -1,
				title: $t('Not specified'),
			},
			financeCategoryIfNotValueObj: {
				id: -1,
				name: $t('Not specified'),
			},
			financeGroupIfNotValueObj: {
				id: -1,
				name: $t('Not specified'),
			},
			financeDestinationIfNotValueObj: {
				value: -1,
				title: $t('Not specified'),
			},
			materialIfNotValueObj: {
				id: -1,
				name: $t('Not specified'),
			},
			materialCategoryIfNotValueObj: {
				id: -1,
				name: $t('Not specified'),
			},
			workOrderIfNotValueObj: {
				id: -1,
				name: $t('Not specified'),
			},
			ifMonthYearIfNotValueObj: {
				value: -1,
				title: $t('Not specified'),
			},
			nullableEntityObjectWithTitleAndValue: {
				value: -1,
				title: $t('Not specified'),
			},
			nullableEntityObjectWithTitleAndId: {
				id: -1,
				title: $t('Not specified'),
			},
			nullableEntityObjectWithNameAndId: {
				id: -1,
				name: $t('Not specified'),
			},
			machineStatusIfNotValueObj: {
				value: -1,
				title: $t('Not specified'),
			},
			machinePropertyIfNotValueObj: {
				value: -1,
				title: $t('Not specified'),
			},
			inspectorIfNotValueObj: {
				id: -1,
				name: $t('Not specified'),
			},
			executorIfNotValueObj: {
				id: -1,
				name: $t('Not specified'),
			},
			supervisorIfNotValueObj: {
				id: -1,
				name: $t('Not specified'),
			},
			orderStatusIfNotValueObj: {
				value: -1,
				title: $t('Not specified'),
			},
			servicePaymentIfNotValueObj: {
				id: -1,
				name: $t('Not specified'),
			},
			deviceTitleIfNotValueObj: {
				id: -1,
				title: $t('Not specified'),
			},
			machineTitleIfNotValueObj: {
				id: -1,
				__title: $t('Not specified'),
			},
			equipmentTitleIfNotValueObj: {
				id: -1,
				__title: $t('Not specified'),
			},
			cargoPackagingIfNotValueObj: {
				value: -1,
				title: $t('Not specified'),
			},
			landActionIfNotValueObj: {
				id: -1,
				name: $t('Not specified'),
			},
			landOwnershipTypeIfNotValueObj: {
				id: -1,
				name: $t('Not specified'),
			},
			landPurposeIfNotValueObj: {
				id: -1,
				name: $t('Not specified'),
			},
			landCategoryIfNotValueObj: {
				id: -1,
				name: $t('Not specified'),
			},
			landReferencesIfNotValueObj: {
				id: -1,
				name: $t('Not specified'),
			},
			staffDepartmentIfNotValueObj: {
				id: -1,
				name: $t('Not specified'),
			},
			cadastralCaseIfNotValueObj: {
				value: -1,
				title: $t('Not specified'),
			},
			planWorkStatusIfNotValueObj: {
				value: -1,
				title: $t('Not specified'),
			},
			tripOwnershipTypeIfNotValueObj: {
				value: -1,
				title: $t('Not specified'),
			},
			staffPermissionIfNotValueObj: {
				value: -1,
				title: $t('Not specified'),
			},
			workStatusIfNotValueObj: {
				value: -1,
				title: $t('Not specified'),
			},
			stageTagIfNotValueObj: {
				id: -1,
				name: $t('Not specified'),
			},
			regulationTagIfNotValueObj: {
				id: -1,
				name: $t('Not specified'),
			},
			businessProcessIfNotValueObj: {
				id: -1,
				name: $t('Not specified'),
			},
			counterpartyIfNotValueObj: {
				id: -1,
				fullname: $t('Not specified'),
			},
			counterpartyTypeIfNotValueObj: {
				id: -1,
				name: $t('Not specified'),
			},
			weightStationIfNotValueObj: {
				id: -1,
				name: $t('Not specified'),
			},
			eventTypeIfNotValueObj: {
				id: -1,
				name: $t('Not specified'),
				// iconKey: 'question-circle',
			},
			identityCardIfNotValueObj: {
				id: -1,
				code: $t('Not specified'),
			},
		}
	})

	return {
		dataEngineNullableObjects,
	}
}
